import Account, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/myreservation/account';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Account;
